import React, { useEffect, useRef } from 'react';
import { oneOf, string, func, object, bool, element } from 'prop-types';

import Editor, { useMonaco, OnChange } from '@monaco-editor/react';
import { css } from '@emotion/css';
/* eslint-disable */

const editorContainer = css`
  position: relative;

  button {
    position: absolute;
    top: 0px;
    right: 13px;
    width: fit-content;
    height: fit-content;
    background: none;
    padding: 5px 2px;
    color: rgb(117, 190, 255);
    text-decoration: underline;
    font-size: 12px;
    border: none;
    cursor: pointer;
    z-index: 2;
  }
`;

const tidyCode = (editor: any) => {
  if (editor) {
    editor.trigger('', 'editor.action.formatDocument');
  }
};
/* eslint-enable */

interface IMonacoProps {
  language?: 'html' | 'css' | 'json' | 'javascript' | 'yaml';
  theme?: 'light' | 'vs-dark' | 'hc-dark';
  value?: string;
  defaultValue?: string;
  onChange?: OnChange;
  onBlur?: Function;
  options?: object;
  height?: string;
  width?: string;
  readOnly?: boolean;
  loading?: React.ReactNode;
  customizeMonacoInstance?: Function;
  wrapperClass?: string;
  path?: string;
}

const Monaco = ({
  language,
  value,
  onChange,
  defaultValue,
  options,
  theme,
  height,
  width,
  readOnly,
  loading,
  onBlur,
  customizeMonacoInstance,
  wrapperClass,
  path,
}: IMonacoProps) => {
  const editorRef = useRef(null);
  const monaco = useMonaco();

  useEffect(() => {
    // or make sure that it exists by other ways
    if (monaco) {
      if (typeof customizeMonacoInstance === 'function') {
        customizeMonacoInstance(monaco, editorRef?.current);
      }
    }
  }, [monaco, editorRef.current]);

  const handleEditorDidMount = (editor: any) => {
    editorRef.current = editor;
    editor.onDidBlurEditorWidget(() => {
      if (typeof onBlur === 'function') {
        onBlur();
      }
    });

    setTimeout(() => {
      tidyCode(editor);
    }, 1000);
  };
  return (
    <div
      className={`${wrapperClass} ${editorContainer}`}
      style={{ width, height }}
    >
      {!readOnly && (
        <button
          type="button"
          onClick={() => {
            tidyCode(editorRef.current);
          }}
        >
          Beautify
        </button>
      )}
      <Editor
        path={path}
        theme={theme}
        defaultValue={defaultValue}
        options={{
          ...options,
          readOnly,
        }}
        onMount={handleEditorDidMount}
        language={language}
        value={value}
        onChange={onChange}
        height="100%"
        width="100%"
        loading={loading}
      />
    </div>
  );
};

Monaco.defaultProps = {
  language: 'json',
  value: '',
  defaultValue: '',
  onChange: undefined,
  onBlur: () => {},
  options: {},
  theme: 'vs-dark',
  height: '100%',
  width: '100%',
  readOnly: false,
  loading: <h3>take a deep breath...</h3>,
  customizeMonacoInstance: undefined,
  wrapperClass: '',
  path: undefined,
};

Monaco.propTypes = {
  language: oneOf(['html', 'css', 'json', 'javascript', 'yaml']),
  theme: oneOf(['light', 'vs-dark', 'hc-dark']),
  value: string,
  defaultValue: string,
  onChange: func,
  onBlur: func,
  options: object,
  height: string,
  width: string,
  readOnly: bool,
  loading: element,
  customizeMonacoInstance: func,
  wrapperClass: string,
  path: string,
};

export default Monaco;
